export const ExpandVariant = { // eslint-disable-line
  Root: 'root',
  Interior: 'interior',
  Scene: 'scene',
  Models: 'models',
  Lights: 'lights',
};
